<template>
    <div>
        <z-title title="会员充值记录" ref="title"></z-title>
        <el-card class="content1" ref="search">
           <div class="flex-n fac fjb">
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    placeholder="输入会员卡号"
                    maxlength="8"
                    clearable
                    title="输入要搜索的会员卡号"
                    prefix-icon="el-icon-search"
                    v-model="memberCardNo"

            >
            </el-input>
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    type="number"
                    clearable
                    placeholder="输入会员电话号码"
                    title="输入会员电话号码"
                    prefix-icon="el-icon-search"
                    maxlength="11"
                    v-model="memberPhone">
            </el-input>
            <store-list class="mr-10"  clearable size="medium" v-model="storeId" placeholder="选择消费门店"></store-list>
            <el-date-picker
                    size="medium"
                    class="mr-10 date"
                    v-model="dateRange"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="请选择开始日期"
                    end-placeholder="请选择结束日期"
                    :picker-options="pickerOptions"
            >
            </el-date-picker>
            <el-button type="primary" class="ele-btn2" @click="searchRecharge">查询</el-button>
           </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="memberNo"
                        label="会员卡号"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="memberName"
                        label="姓 名"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="memberPhone"
                        label="手机号码"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="billDatetime"
                        label="充值时间"
                        width="170"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="paymentTypeName"
                        label="支付类别"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="billMoney"
                        label="充值金额"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="storeName"
                        label="充值门店"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserName"
                        label="操作员"
                        width="130"
                        align="center">
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
       
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import WantHouse from "../../components/data/wantHouse";
    import StoreList from "../../components/data/storeList";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            StoreList,
            WantHouse,
            ZTitle},
        name: "recharge",
        data(){
            return{
                loading: false,
                pageSize: 20,
                currentPage: 1,
                height:250,
                total: 0,
                dataForm: {},
                dataList: [],

                memberCardNo:'',
                memberPhone:'',
                storeId:'',
                dateRange:[],
                showinfo:true,
            }
        },
        mounted(){
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.getRecharge();
        },
        computed:{
            pickerOptions() {
                var that=this;
                return{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year=start.getFullYear(),month=start.getMonth()+1;
                                var startDate=new Date(year+'-'+month+'-1');
                                var length=that.$TM.getMonthArea().length-1;
                                var dd=that.$TM.getMonthArea()[length].dd;
                                var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                                console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                                var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                                    year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                                var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                                var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                                var startDate=new Date(year+'-'+month+'-1');
                                var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            },
        },
        methods:{
            //查询会员消费记录
            getRecharge() {
                this.loading = true;
                this.$axios.post('/bill/rechargeList', {
                    "memberCardNo": this.memberCardNo,
                    "memberPhone": this.memberPhone,
                    "storeId": this.$root.getStorage('storeId'),
                    "startTime": this.dateRange?this.dateRange[0]:'',
                    "endTime": this.dateRange?this.dateRange[1]:'',
                    "pageNum": this.currentPage,
                    "pageSize": this.pageSize,
                }).then(res => {
                    console.log('列表', res);
                    this.dataList = res.data.list;
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            //搜索
            searchRecharge() {
                this.currentPage = 1;
                this.getRecharge();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getRecharge();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getRecharge();
                console.log(`当前页: ${val}`);
            },
        }
    }
</script>

<style scoped>

</style>